module.exports = __webpack_public_path__ + "img/hero-dr3.450f6ef.jpg";